import { render, staticRenderFns } from "./MySalesIndex.vue?vue&type=template&id=5c305540&"
import script from "./MySalesIndex.vue?vue&type=script&lang=js&"
export * from "./MySalesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports